<template>
  <v-simple-table>
    <tbody class="info-table">
      <tr rowspan="3">
        <td colspan="2">
          <span>{{ $t('partDetailsPage.infoTable.description') }}</span>
          <p class="mt-2">{{ info ? info.description : '' }}</p>
        </td>
      </tr>
      <tr>
        <td>{{ $t('partDetailsPage.infoTable.vin') }}</td>
        <td>
          <div>
            <span>{{ info.vin }}</span>
            <CopyButton :text="info.vin" />
          </div>
        </td>
      </tr>
      <tr>
        <td>{{ $t('partDetailsPage.infoTable.location') }}</td>
        <td>
          <div>
            <v-text-field
              :value="location"
              hide-details
              dense
              @change="onLocationChange"
            ></v-text-field>
            <CopyButton :text="info.warehouse_location" />
          </div>
        </td>
      </tr>
      <tr>
        <td>{{ $t('partDetailsPage.infoTable.condition') }}</td>
        <td>
          <div>
            <!-- <span>{{ info.part_condition }}</span> -->
            <v-select
              v-model="info.part_condition"
              :items="conditions"
              hide-details
              dense
              @change="onConditionChange"
            ></v-select>
            <CopyButton :text="info.part_condition" />
          </div>
        </td>
      </tr>
      <tr>
        <td>{{ $t('partDetailsPage.infoTable.status') }}</td>
        <td>
          <div>
            <!-- <span>{{ info.physical_location }}</span> -->
            <v-select
              v-model="info.physical_location"
              :items="statuses"
              hide-details
              dense
              @change="onStatusChange"
            ></v-select>
            <CopyButton :text="info.physical_location" />
          </div>
        </td> 
      </tr>
      <tr>
        <td>{{ $t('partDetailsPage.infoTable.inventory') }}</td>
        <td>
          <div>
            <span>{{ info.dkplus_id }}</span>
            <CopyButton :text="info.dkplus_id" />
          </div>
        </td> 
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import CopyButton from "@/components/common/CopyButton.vue";

export default {
  name: "PartInfoTable",
  components: {
    CopyButton
  },
  props: {
    info: Object
  },
  data() {
    return {
      details: {},
      conditions: ['A', 'B', 'C'],
      statuses: ['IN_CAR','WAITING_PROCESSING','PROCESSING','WAITING_STORAGE','RESERVED','IN_WAREHOUSE','SOLD','RETURNED']
    }
  },
  methods: {
    fillDetails() {
      if (!('part_id' in this.details)) {
        this.details = this.info
      }
    },
    onConditionChange(value) {
      this.fillDetails()
      this.details.part_condition = value
    },
    onStatusChange(value) {
      this.fillDetails()
      this.details.physical_location = value
    },
    onLocationChange(value) {
      this.fillDetails()
      this.details.warehouse_location = value
    }
  },
  computed: {
    location: function(){
      if (this.info.warehouse_location_aisle == null) {
        return '';
      }
      let part_location = 
        this.info.warehouse_location_aisle 
        + "-" + 
        this.info.warehouse_location_unit 
        + "-" + 
        this.info.warehouse_location_shelf

        if (this.info.warehouse_location_bin != null) {
          part_location += "-"
          part_location += this.info.warehouse_location_bin
        }
      return (part_location)
    }
  }
}
</script>

<style scoped>
.info-table {
  text-align: left;
  font-size: 0.875rem;
  color: #333333;
}

td div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>